import React, {Component} from 'react';
import { connect } from 'react-redux'
import axios from 'axios'
import {toastr} from 'react-redux-toastr'

import config from '../../config'
import {setToken} from '../../actions/layout'

import { checkIfLoggedIn } from '../../auth'

import Translate, {translate} from '../../translate'

class LoginComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      emailForm: true,
      email: '',
      userId: '',
      token: '',
    }
  }

  authenticate = (e) => {
    e.preventDefault()
    const data = {
      org: this.props.settings.organizationName,
      email: this.state.email,
      preferredLanguage: this.props.settings.language
    }
    axios.post(`${config.apiUrl}/authenticate`, data)
      .then(r => {
        console.log('r', r)
        if (r.data.emailTokenSent) {
          this.setState({emailForm: false, userId: r.data.user.id})
        } else if (r.data.token) {
          const myStorage = window.localStorage
          myStorage.setItem('token', `Bearer ${r.data.token}`)
          checkIfLoggedIn({dispatch: this.props.dispatch})
        }
      })
      .catch(e => {
        console.error('error: ', e)
        const authenticationError = translate('login.authenticationError', this.props.settings.language)
        toastr.error(authenticationError[0], authenticationError[1])
      })
  };

  verifyToken = (e) => {
    e.preventDefault()
    const data = {
      org: this.props.settings.organizationName,
      email: this.state.email,
      token: this.state.token,
      userId: this.state.userId
    }
    axios.post(`${config.apiUrl}/verify-token`, data)
      .then(r => {
        console.log(r.data)
        if (r.data.token) {
          const myStorage = window.localStorage
          myStorage.setItem('token', `Bearer ${r.data.token}`)
          checkIfLoggedIn({dispatch: this.props.dispatch})
        } else {
          const missingTokenError = translate('login.missingTokenError', this.props.settings.language)
          toastr.error(missingTokenError[0], missingTokenError[1])
        }
      })
      .catch(e => {
        console.error('error: ', e)
        const verifyTokenError = translate('login.verifyTokenError', this.props.settings.language)
        toastr.error(verifyTokenError[0], verifyTokenError[1])
      })
  };

  render() {

   const emailLogin = (
    <form onSubmit={e => this.authenticate(e)}>
      {/*<div dangerouslySetInnerHTML={{__html: '<'+this.props.settings.customHtmlMarkup.subheaderTag+'>Logg inn</'+this.props.settings.customHtmlMarkup.subheaderTag+'>'}} />*/}
      <div className={this.props.settings.customCssClasses.inputWrapperClass}>
        <input type="email" 
               className={this.props.settings.customCssClasses.inputClass} 
               autoComplete="new-password"
               value={this.state.email} 
               onChange={e => this.setState({email: e.target.value})} 
               placeholder={translate('login.inputEmail', this.props.settings.language)} />
      </div>
      <input type="submit" className={this.props.settings.customCssClasses.submitButtonClass} value={translate('login.submitButton', this.props.settings.language)} />
    </form>
  )

   const tokenForm = (
    <form onSubmit={e => this.verifyToken(e)}>
      {/*<div dangerouslySetInnerHTML={{__html: '<'+this.props.settings.customHtmlMarkup.subheaderTag+'>E-post sendt</'+this.props.settings.customHtmlMarkup.subheaderTag+'>'}} />*/}
      <p><Translate value="login.tokenSent" language={this.props.settings.language} /></p>
      <div className={this.props.settings.customCssClasses.inputWrapperClass}>
        <input type="text" 
               className={this.props.settings.customCssClasses.inputClass} 
               autoComplete="new-password"
               value={this.state.token} 
               onChange={e => this.setState({token: e.target.value})} />
     </div>
      <input type="submit" className={this.props.settings.customCssClasses.submitButtonClass} value={translate('login.loginButton', this.props.settings.language)} />
    </form>
  )

   return this.state.emailForm ? emailLogin : tokenForm
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    authenticate: state.authenticate,
    settings: state.settings,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  }
}

const Login = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginComponent);

export default Login



// WEBPACK FOOTER //
// ./src/containers/login/index.js